import { isArray, isDefined, isUndefined } from './isDefined';

export default function searchCaseInsensitive(value, searchTerm) {
  if (isArray(searchTerm)) {
    return searchInArray({ value, searchTerm });
  }

  if (isUndefined(value)) {
    return false;
  }

  return checkValue(value, searchTerm);
}

function searchInArray({ value, searchTerm }) {
  if (searchTerm.length === 0) {
    return true;
  }

  if (
    isUndefined(value) &&
    isDefined(searchTerm.find(term => term === 'null'))
  ) {
    return true;
  }

  if (isUndefined(value)) {
    return false;
  }

  return searchTerm.filter(term => checkValue(value, term)).length > 0
    ? true
    : false;
}

function checkValue(value, searchTerm) {
  if (isUndefined(value) || isUndefined(searchTerm)) {
    return false;
  }

  const valueStr = value.toString().toLowerCase();
  const trimmedSearchTerm = searchTerm.toString().trim();
  if (trimmedSearchTerm === '') {
    return true;
  }

  if (trimmedSearchTerm.startsWith('%')) {
    const searchValue = trimmedSearchTerm.substring(1).toLowerCase();
    return valueStr.endsWith(searchValue);
  }

  if (trimmedSearchTerm.endsWith('%')) {
    const searchValue = trimmedSearchTerm
      .substring(0, trimmedSearchTerm.length - 1)
      .toLowerCase();
    return valueStr.startsWith(searchValue);
  }

  return valueStr.indexOf(trimmedSearchTerm.toLowerCase()) !== -1;
}
